import React from 'react';
import { useThreadLoading } from '../../../contexts/ThreadLoadingContext';
import ProgressBarAnimation from './ProgressBarAnimation';
import { formatToolDisplay } from '../../../utils/toolFormatting';
import './async-tool-display.scss';

interface AsyncToolDisplayProps {
  threadId: string | null;
}

const AsyncToolDisplay: React.FC<AsyncToolDisplayProps> = ({ threadId }) => {
  const { asyncTools } = useThreadLoading();

  // Filter tools for the current thread, excluding those with ERROR or COMPLETED status
  const currentThreadTools = Object.values(asyncTools).filter(
    (tool) =>
      tool.threadId === threadId &&
      tool.status !== 'ERROR' &&
      tool.status !== 'ABORTED' &&
      tool.status !== 'COMPLETED',
  );

  if (currentThreadTools.length === 0) {
    return null;
  }

  return (
    <div className='async-tool-display'>
      {currentThreadTools.map((tool) => (
        <div
          key={tool.tool_id}
          className={`async-tool-item ${tool.status === 'INITIATED' ? 'queued' : ''}`}
        >
          <div className='async-tool-info'>
            <div className='async-tool-name'>
              {tool.status === 'INITIATED'
                ? 'Preparing'
                : tool.status === 'PRE_ERROR'
                  ? 'Error'
                  : 'Working'}
            </div>
            {tool.status !== 'PRE_ERROR' && <ProgressBarAnimation />}
          </div>

          <div className='async-tool-progress'>
            <div className='progress-pill'>{formatToolDisplay(tool.name)}</div>
            {tool.progress > 0 && (
              <div className='progress-pill'>{tool.progress}% complete</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AsyncToolDisplay;
